export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
          联系投稿
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-xl mx-auto">
          欢迎韩漫爱好者、创作者及内容合作方与我们联系。无论是投稿推荐、版权合作还是广告商务，我们都会在第一时间回复您的咨询。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <div className="flex items-center gap-2 bg-background-50 px-5 py-3 rounded-lg border border-background-200/70">
            <i className="ri-mail-line text-primary-500 text-lg"></i>
            <span className="text-sm text-foreground-700">contact@hanman.com</span>
          </div>
          <div className="flex items-center gap-2 bg-background-50 px-5 py-3 rounded-lg border border-background-200/70">
            <i className="ri-wechat-line text-primary-500 text-lg"></i>
            <span className="text-sm text-foreground-700">韩漫网官方</span>
          </div>
        </div>
      </div>
    </section>
  );
}